// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"FaqFilter_outerContainer__Isxu2","item":"FaqFilter_item__rvwzW","container":"FaqFilter_container__70tRG"};